export default "__VITE_ASSET__ILDm2JeI__"